import React from "react";
import styled from "@emotion/styled";
import Shared02Headings from "../../../guestsharedcomponents/Shared02Headings/Shared02Headings";
import CanvasHeroBackground from "./CanvasHeroBackground/CanvasHeroBackground";

const ContainerSection = styled.section`
  position: relative;
  width: 100%;
  height: 105dvh;
  overflow: hidden;

  .slider-i {
    height: 105dvh;
    position: relative;
    z-index: 1;
  }

  .conatiner-img {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: -1;

    img {
      max-width: 58rem;
    }
  }
`;

const S01Slider01 = () => {
  return (
    <ContainerSection className="t-flex t-flex-ac">
      <CanvasHeroBackground
        options={{
          bg_color_mobile: "rgba(0, 0, 0, 0.4)",
          bg_color_desktop:
            "linear-gradient( to right, transparent 30%, rgb(0, 0, 0) 80%,rgba(0, 0, 0, 0.99) 75% )",
        }}
      />

      <div className="t-container slider-i t-flex-op1">
        <Shared02Headings
          options={{
            style_render: "992",
            main_container_css: "",
            container_mobile_styles: {
              flex: "0 0 100%",
              "max-width": "100%",
            },
            container_desktop_styles: {
              flex: "0 0 60%",
              "max-width": "60%",
            },
            obj_heading: {
              main_text:
                "Learn Bachata Online With <span class='t-enlace'>Confidence</span>",
              main_tag_version: "h1",
              main_text_css: "",
              heading_mobile_styles: {
                color: "#fff",
                "font-family": "'Exo 2', sans-serif",
                "font-weight": "900",
                "font-size": "5.5rem",
                "line-height": "1.1",
                "text-transform": "capitalize",
                "margin-bottom": "2rem",
                "text-shadow":
                  "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
                "text-align": "center",
              },
              heading_desktop_styles: {
                "font-size": "7rem",
              },
            },
            obj_support_heading: {
              main_text: "Not Random Moves. Real Connection.",
              main_tag_version: "h2",
              main_text_css: "",
              heading_mobile_styles: {
                color: "#fff",
                "font-family": "'Exo 2', sans-serif",
                "font-weight": "900",
                "font-size": "3rem",
                "line-height": "1.1",
                "text-transform": "capitalize",
                "margin-bottom": "1rem",
                "text-shadow":
                  "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
                "text-align": "center",
              },
              heading_desktop_styles: {
                "font-size": "2.5rem",
              },
            },

            obj_divider: {
              divider_mobile_styles: {
                width: "70%",
                background:
                  "linear-gradient(90deg, transparent, #e6c28b, transparent)",
                margin: "0 auto 2rem auto",
              },
              divider_desktop_styles: false,
            },
            obj_paragraph: {
              main_text:
                "Train with Luis & Tay inside a structured online academy built to help you dance with control, expression, and presence",
              main_tag_version: "p",
              main_text_css: "",
              paragraph_mobile_styles: {
                color: "#fff",
                "font-size": "1.8rem",
                "margin-bottom": "5rem",
                "text-align": "center",
                "text-shadow":
                  "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
              },
              paragraph_desktop_styles: false,
            },
            obj_buttons: {
              main_objinfo: {
                icon_left: false,
                icon_right: { icon: "fa-solid fa-arrow-right-long" },
                main_btn_heading: "Start Your Learning Today",
                main_btn_link: "https://members.ltmastery.com/",
                main_btn_container_classes: "t-btn-principal-1 t-mb-1 t-mr-1",
                main_btn_classes: "t-uppercase t-font-1-4",
                main_btn_version: "external_link_button", //main_button, internal_link_button, external_link_button
                main_btn_loader: false,
                main_handleClick: false,
              },
              secundary_objinfo: {
                icon_left: false,
                icon_right: false,
                main_btn_heading: "See the Learning Path",
                main_btn_link: "https://members.ltmastery.com/",
                main_btn_container_classes: "t-btn-principal-2 t-mb-1",
                main_btn_classes: "t-capitalize t-font-italic t-font-1-4",
                main_btn_version: "external_link_button", //main_button, internal_link_button, external_link_button
                main_btn_loader: false,
                main_handleClick: false,
              },
              btn_main_container_classes: "t-flex-jsc t-flex-wrap",
            },
            heading_version: "heading_01",
          }}
        />
        <div className="conatiner-img">
          <img
            src="https://res.cloudinary.com/djiqf3usa/image/upload/v1768603035/Clients/LTMastery/Frontpage/Images/Imagenes%20con%20SEO/luis-and-tay-sensual-bachata-online-instructors-hero_enmpdq.webp"
            alt="Luis and Tay, sensual bachata instructors teaching online with focus on confidence and connection"
          />
        </div>
      </div>
    </ContainerSection>
  );
};

export default S01Slider01;
